

function InfosPanierFinal({ total }) {



    return (
        <div className="infos-panier-final">
            <p>Prix total du panier :</p>
            <h4>{total},00€</h4>

        </div>

    )
}




export default InfosPanierFinal